import _classCallCheck from "/app/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/app/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _callSuper from "/app/node_modules/@babel/runtime/helpers/esm/callSuper.js";
import _inherits from "/app/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _defineProperty from "/app/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import "core-js/modules/es.array.concat.js";
import { __decorate } from "tslib";
import { Vue, Options } from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
var UserAccountDeleteDialog = /*#__PURE__*/function (_Vue) {
  function UserAccountDeleteDialog() {
    var _this;
    _classCallCheck(this, UserAccountDeleteDialog);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, UserAccountDeleteDialog, [].concat(args));
    _defineProperty(_this, "toggleDialog", void 0);
    _defineProperty(_this, "visible", false);
    return _this;
  }
  _inherits(UserAccountDeleteDialog, _Vue);
  return _createClass(UserAccountDeleteDialog, [{
    key: "onDialogClose",
    value: function onDialogClose() {
      this.visible = false;
      this.$emit("dialogClose");
    }
  }, {
    key: "onDeleteConfirm",
    value: function onDeleteConfirm() {
      this.visible = false;
      this.$emit("deleteConfirm");
    }
  }]);
}(Vue);
__decorate([Prop({
  default: false
})], UserAccountDeleteDialog.prototype, "toggleDialog", void 0);
UserAccountDeleteDialog = __decorate([Options({
  watch: {
    toggleDialog: function toggleDialog() {
      this.visible = this.toggleDialog;
    }
  }
})], UserAccountDeleteDialog);
export default UserAccountDeleteDialog;